import { Editor, EditorContent } from '@tiptap/react';
import React, { FC } from 'react';

import { Box, StyleProps } from '@bonusly/design-system';

import { useInputRole } from './hooks/use-input-role';
import { InputStyles, useInputStyle } from './hooks/use-input-style';
import { LinkBubbleMenu } from './link-bubble-menu';

export interface RichMediaInputProps extends StyleProps {
	editor: Editor | null;
	inputStyles?: InputStyles;
	uniqueId: string;
}

export const RichMediaInput: FC<RichMediaInputProps> = ({ editor, inputStyles, uniqueId, ...props }) => {
	const style = useInputStyle(inputStyles);
	useInputRole(uniqueId);

	if (!editor) {
		return null;
	}

	const hasLinkExtension = editor.extensionManager.extensions.some((extension) => extension.name === 'link');

	return (
		<Box css={style} fontSize="xl" letterSpacing="-0.01em" lineHeight={8} overflow="hidden" {...props}>
			{editor.isEditable && hasLinkExtension && <LinkBubbleMenu editor={editor} />}
			<EditorContent
				id={`editor-${uniqueId}`}
				editor={editor}
				style={{
					height: '100%',
					...(inputStyles as React.CSSProperties),
				}}
			/>
		</Box>
	);
};
